import { Action } from '@ngrx/store';

export class BillingAction implements Action {

    public static getBrokerageTax: string = '[Billing] get_brokerage_tax';
    public static getBrokerageTaxError: string = '[Billing] get_brokerage_tax_error';
    public static getBrokerageTaxSuccess: string = '[Billing] get_brokerage_tax_success';

    public static getBrokerageModel: string = '[Billing] get_brokerage_model';
    public static getBrokerageModelError: string = '[Billing] get_brokerage_model_error';
    public static getBrokerageModelSuccess: string = '[Billing] get_brokerage_model_success';

    public static setBrokerageModel: string = '[Billing] set_brokerage_model';
    public static setBrokerageModelError: string = '[Billing] set_brokerage_model_error';
    public static setBrokerageModelSuccess: string = '[Billing] set_brokerage_model_success';

    public static getLastMonthlyScore: string = '[Billing] get_last_monthly_score';
    public static getLastMonthlyScoreError: string = '[Billing] get_last_monthly_score_error';
    public static getLastMonthlyScoreSuccess: string = '[Billing] get_last_monthly_score_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
